<template>
  <section class="specialized">

    <div class="specialized__container container">
      <div class="specialized__title">

        <h2 class="specialized__title--h2">
          Servicios Especializados
        </h2>

        <p class="specialized__title--p">
          soluciones a medida para tus procesos
        </p>

      </div>

      <div class="specialized__content">
        <div class="specialized__info">
          <div class="specialized__row">
            <div class="specialized__card">

              <div class="specialized__card--info">
                <i class="specialized__card--i ri-bubble-chart-line"></i>
                <h4 class="specialized__card--h4">
                  Analítica de datos Bi
                </h4>
                <p class="specialized__card--p">
                  Implementación de inteligencia de negocios para transformar
                  datos en insights estratégicos mediante reportes y dashboards interactivos.
                </p>
              </div>

              <!-- <div class="specialized__card--cta">
                <a class="specialized__card--a" href="">
                  Ver más
                  <i class="ri-arrow-right-up-line"></i>
                </a>
              </div> -->

            </div>

            <div class="specialized__card">
              <div class="specialized__card--info">

                <i class="specialized__card--i ri-terminal-line"></i>

                <h4 class="specialized__card--h4">
                  Desarrollo a medida
                </h4>

                <p class="specialized__card--p">
                  Creación de funcionalidades personalizadas para adaptarse a necesidades específicas
                  del centro médico, mejorando la eficiencia operativa.
                </p>

              </div>

             <!--  <div class="specialized__card--cta">
                <a class="specialized__card--a" href="">
                  Ver más
                  <i class="ri-arrow-right-up-line"></i>
                </a>
              </div> -->

            </div>
          </div>

          <div class="specialized__row">

            <div class="specialized__card">

              <div class="specialized__card--info">
                <i class="specialized__card--i ri-presentation-fill"></i>
                <h4 class="specialized__card--h4">
                  Recapacitación
                </h4>
                <p class="specialized__card--p">
                  Capacitación continua del personal en el uso de Exalab para maximizar
                  el aprovechamiento de las funcionalidades del sistema.
                </p>
              </div>

             <!--  <div class="specialized__card--cta">
                <a class="specialized__card--a" href="">
                  <span>Ver más</span>
                  <i class="ri-arrow-right-up-line"></i>
                </a>
              </div> -->

            </div>

            <div class="specialized__card">

              <div class="specialized__card--info">
                <i class="specialized__card--i ri-flow-chart"></i>
                <h4 class="specialized__card--h4">
                  Integraciones
                </h4>
                <p class="specialized__card--p">
                  Conexión fluida de Exalab con otros sistemas y herramientas, mejorando la
                  interoperabilidad y el flujo de información.
                </p>
              </div>

     <!--          <div class="specialized__card--cta">
                <a class="specialized__card--a" href="">
                  Ver más
                  <i class="ri-arrow-right-up-line"></i>
                </a>
              </div> -->

            </div>

          </div>

        </div>

        <div class="specialized__featured">

          <img class="specialized__featured--img" :src="'assets/img/specialized/services.png'" alt="">

        </div>

      </div>

      <div class="specialized__mobile">

        <div class="specialized__mobile--feature">
          <img :src="'assets/img/specialized/' + currentService.image" class="specialized__mobile--img">
        </div>

        <div class="specialized__mobile--info">
          <div class="specialized__mobile--card">
            <i :class="['specialized__mobile--i', currentService.icon]"></i>
            <h4 class="specialized__mobile--h4">
              {{ currentService.title }}
            </h4>
            <p class="specialized__mobile--p">
              {{ currentService.description }}
            </p>
           <!--  <a href="#" class="specialized__mobile--a">
              Ver más
              <i class="ri-arrow-right-up-line"></i>
            </a> -->

            <div class="specialized__mobile--left" @click="previousService">
              <i class="ri-arrow-left-s-line"></i>
            </div>

            <div class="specialized__mobile--right" @click="nextService">
              <i class="ri-arrow-right-s-line"></i>
            </div>

          </div>
        </div>

      </div>



    </div>

  </section>
</template>
<script lang="ts" setup>
import { ref, computed } from "vue"

interface SpecializedService {
  title: string;
  description: string;
  icon: string;
  image: string;
}

const services = ref<SpecializedService[]>([
  {
    title: 'Analítica de datos Bi',
    description: 'Implementación de inteligencia de negocios para transformar datos en insights estratégicos mediante reportes y dashboards interactivos.',
    icon: 'ri-bubble-chart-line',
    image: '1.jpg'
  },
  {
    title: 'Desarrollo a medida',
    description: 'Creación de funcionalidades personalizadas para adaptarse a necesidades específicas del centro médico, mejorando la eficiencia operativa.',
    icon: 'ri-terminal-line',
    image: '2.jpg'
  },
  {
    title: 'Recapacitación',
    description: 'Capacitación continua del personal en el uso de Exalab para maximizar el aprovechamiento de las funcionalidades del sistema.',
    icon: 'ri-presentation-fill',
    image: '3.jpg'
  },
  {
    title: 'Integraciones',
    description: 'Conexión fluida de Exalab con otros sistemas y herramientas, mejorando la interoperabilidad y el flujo de información.',
    icon: 'ri-flow-chart',
    image: '4.jpg'
  }
]);

const currentIndex = ref(0);

const currentService = computed(() => services.value[currentIndex.value]);

const nextService = () => {
  currentIndex.value = (currentIndex.value + 1) % services.value.length;
};

const previousService = () => {
  currentIndex.value = currentIndex.value === 0 ? services.value.length - 1 : currentIndex.value - 1;
};

</script>
